import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

import { AppClientContext } from "src/app-client/_appCommon/base/AppClientContext";
import { AppEventNames } from 'src/app-client/_appCommon/base/Constants';
import { BroadcastManager } from 'src/app-client/_appCommon/base/BroadcastManager';
import { CustomerDataService } from "src/app-client/_dataservices/CustomerDataService";
import { OrderDetailDataService } from '../../../_dataservices/OrderDetailDataService';
import { Product, GlobalConstants } from 'src/app/_appCommon/base/AppInterfaceAndBaseClasses';
import { UrlQueryDef } from 'src/app-client/_appCommon/base/UrlQueryDef';

@Component({
  selector: 'app-purchased-product-list',
  templateUrl: './purchased-product-list.component.html',
  styleUrls: ['./purchased-product-list.component.css'],
  providers: [CustomerDataService, OrderDetailDataService]
})
export class PurchasedProductListComponent
{
  public availableProducts: any = [];
  public currentCustomer: any;
  public customerId: number = 0;
  public dataSource: Array<Product> = [];
  public notFoundImagePath = GlobalConstants.altProductImagePath;
  public productSelected: any;

  public unsubscribe: Subject<boolean> = new Subject();

  constructor(
    private customerDataService: CustomerDataService,
    private orderDetailDataService: OrderDetailDataService,
    private router: Router,
  )
  {

  }

  public ngOnInit()
  {
    if(AppClientContext.Instance.customerId)
      this.customerId = AppClientContext.Instance.customerId;
    else
      this.getCustomerInfo();

    this.orderDetailDataService.getCustomerProductList(this.getQueryDefForGetByCustomerId())
      .subscribe(response =>
      {
        this.availableProducts = response.records;
      }, (fail) =>
      {

      });
  }

  ngOnDestroy(): void
  {
    this.unsubscribe.next(true);
    this.unsubscribe.unsubscribe();
  }

  public onSelectProduct(product: any): void
  {
    this.productSelected = product;
  }

  public onConfirmProductSelected(): void
  {
    BroadcastManager.Instance.broadcast(AppEventNames.onSelectPurchasedProduct, this.productSelected);
  }

  // gets the current customer information
  private getCustomerInfo() : void
  {
    if (AppClientContext.Instance.user)
    {
      this.customerDataService.getByUserId(AppClientContext.Instance.user.id)
        .subscribe((response: any) =>
        {
          let currentCustomer = response.items.firstOrNull();
          if (currentCustomer)
          {
            AppClientContext.Instance.customerId = currentCustomer.id;
            this.currentCustomer = currentCustomer;
          }
        });
    }
  }

  private getFirstProductImage(): void
  {
    for (let i = 0; i < this.availableProducts.length; i++)
    {
      let productImage = this.availableProducts[i].images.firstOrNull();
      this.availableProducts[i].imagePath = productImage ? productImage.url : this.notFoundImagePath;
    }
  }

  protected getQueryDefForGetByCustomerId(): UrlQueryDef
  {
    let queryDef: UrlQueryDef = new UrlQueryDef();
    queryDef.includes = "PriceList, SpecList";
    queryDef.addParam("CustomerId", this.customerId);
    return queryDef;
  }
}
